export function parsePrePack(options) {
    const { prePack, oddsStyle, localization, } = options;
    return {
        id: prePack.id,
        americanOdds: prePack.americanOdds,
        displayOdds: prePack.displayOdds[oddsStyle],
        selections: prePack.selections.map(x => parseSelection(x, localization)),
        isLive: prePack.isLive,
        isSuspended: prePack.isSuspended,
        isLocked: prePack.isLocked,
        isInitialPull: prePack.isInitialPull,
        hasBeenReplaced: !!prePack.replacedPrePackId,
    };
}
function parseSelection(selection, localization) {
    const pointsFormatted = localization.formatPoints(selection);
    const pointsPart = pointsFormatted !== "" ? ` ${pointsFormatted}` : "";
    return {
        id: selection.id,
        name: `${selection.selectionName}${pointsPart}`,
        marketName: selection.marketName,
    };
}
//# sourceMappingURL=parsePrePack.js.map